module.exports = __webpack_public_path__ + "static/media/error.35b93f1f.svg";